<script setup lang="ts">
/**
 * CampaignSecurityBadge — badge "Cagnotte vérifiée" / "Paiement sécurisé".
 *
 * Composant PARTAGÉ (@donoor/ui) consommé en SOURCE par dashboard.donoor.org
 * et donoor.org. Couleurs en hex en dur (pas de token de thème) → rendu
 * identique dans les 2 apps malgré leurs thèmes différents (vert/bleu).
 *
 * `<UIcon>` reste global (résolu par le module @nuxt/ui de l'app qui transpile
 * ce SFC via build.transpile). `i-lucide-*` + l'API `name`/`class` sont
 * identiques entre Nuxt UI 3.x (donoor.org) et 4.x (dashboard).
 *
 * USAGE (auto-import via wrapper local) :
 *   import CampaignSecurityBadge from "@donoor/ui/campaign/CampaignSecurityBadge.vue";
 *
 * Karim 2026-06-21 (factorisation cagnotte).
 */
// Internationalisation (lot "paquets partagés", 2026-10-11) : clés `ui.*`,
// présentes dans donoor.org ET dashboard.donoor.org (useI18n auto-importé).
const { t } = useI18n();

withDefaults(
  defineProps<{
    isVerified?: boolean;
  }>(),
  { isVerified: false },
);
</script>

<template>
  <div
    v-if="isVerified"
    class="inline-flex items-center gap-2 rounded-full bg-[#1f9afe]/15 px-3 py-1.5 text-xs font-medium text-[#0F3D8C]"
  >
    <UIcon name="i-lucide-badge-check" class="size-3.5" />
    <span>{{ t("ui.securityBadge.verifiee") }}</span>
  </div>

  <div
    v-else
    class="inline-flex items-center gap-2 rounded-full bg-gray-100 px-3 py-1.5 text-xs font-medium text-gray-600"
  >
    <UIcon name="i-lucide-shield-check" class="size-3.5" />
    <span>{{ t("ui.securityBadge.securisee") }}</span>
  </div>
</template>
